<template>
  <div class="mb-2">
    <a-row :gutter="8">
      <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <a-input v-model:value="queryForm.name" placeholder="商户ID/名称" style="width:100%;" allow-clear />
      </a-col>
      <a-col :xxl="3" :xl="6" :lg="12" :md="24" :sm="24" :xs="24">
        <a-select v-model:value="queryForm.isvip" placeholder="请选择会员状态" style="width:100%;" allow-clear>
          <a-select-option value="yes">已开通</a-select-option>
          <a-select-option value="no">未开通</a-select-option>
        </a-select>
      </a-col>
      <a-col :xxl="4" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <a-space>
          <a-button type="primary" @click="getData()">查询</a-button>
          <a-button type="primary" class="btn-success" @click="add">
            <template #icon>
              <PlusOutlined />
            </template>
            新增商户
          </a-button>
        </a-space>
      </a-col>
    </a-row>
  </div>
  <a-table size="small" :columns="columns" bordered :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: height }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }">
    <template #headerCell="{ column }">
      <template v-if="column.dataIndex === 'org'">
        <p>商户ID</p>
        <p>商户名称</p>
      </template>
      <template v-if="column.dataIndex === 'seller'">
        <p>主账号</p>
        <p>初始密码</p>
      </template>
      <template v-if="column.dataIndex === 'link'">
        <p>联系人</p>
        <p>联系电话</p>
      </template>
      <template v-if="column.dataIndex === 'vip'">
        <p>会员类型</p>
        <p>会员有效期</p>
        <p>是否缴费</p>
      </template>
    </template>
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        <p>{{ record.number }}</p>
        <p>{{ record.name }}</p>
      </template>
      <template v-if="column.dataIndex === 'seller'">
        <p>{{ record.username }}</p>
        <p>{{ record.initpwd || '已修改' }}</p>
      </template>
      <template v-if="column.dataIndex === 'is_open_sc'">
        <a-switch v-model:checked="record.is_open_sc" :loading="changeing_open_sc[record._id]"
          @change="(checked, e) => change_open_sc(record._id, checked)" />
      </template>
      <template v-if="column.dataIndex === 'is_open_tms'">
        <a v-if="!record.is_open_tms" @click="change_open_tms(record, true)"> 开通 </a>
        <a v-if="record.is_open_tms">
          <a-tooltip placement="right">
            <template #title>
              <p v-for="item in record.warehouse_names" :key="item">
                {{ item }}
              </p>
            </template>
            <EyeOutlined />
          </a-tooltip>
        </a>
        <!-- <a-switch v-model:checked="record.is_open_tms" :loading="changeing_open_tms[record._id]"
          :disabled="record.is_open_tms" @change="(checked, e) => change_open_tms(record, checked)" /> -->
      </template>
      <template v-if="column.dataIndex === 'logistics_customer_username'">
        <p>{{ record.logistics_customer_username }}</p>
        <p>{{ record.logistics_customer_name }}</p>
        <a v-if="!record.logistics_customer_username" href="javascript:;" @click="bindlogisticscustomer(record)">绑定</a>
        <!-- <a v-else href="javascript:;" class="text-error" @click="bindlogisticscustomer(record)">更换</a> -->
      </template>
      <template v-if="column.dataIndex === 'link'">
        <p>{{ record.linkman }}</p>
        <p>{{ record.linkphone }}</p>
      </template>
      <template v-if="column.dataIndex === 'vip'">
        <p>{{ record.vip_type }}</p>
        <!-- <p>{{ record.vip_begin }}~{{ record.vip_final }}</p> -->
        <p v-if="record.left_days" :style="{ color: record.color }">{{ record.left_days }}</p>
        <p class="text-error">{{ record.paystate === 0 ? '未缴费' : '' }}</p>
        <p class="text-success">{{ record.paystate === 1 ? '已缴费' : '' }}</p>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a href="javascript:;" @click="edit(record)">编辑</a>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="dataModal" :title="dataTitle" @ok="save" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
    :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
    <a-form ref="dataFormRef" name="dataForm" :model="dataForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24" v-if="dataForm.number">
          <a-form-item label="商户ID" name="number">
            {{ dataForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="商户名称" name="name" :rules="[{ required: true, message: '请输入商户名称' }]">
            <a-input v-model:value="dataForm.name" placeholder="商户名称" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="账号" name="username" :rules="[{ required: true, message: '请输入账号' }]">
            <a-input v-model:value="dataForm.username" placeholder="账号" :disabled="dataForm._id !== '' || saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="密码" name="password">
            <a-input v-model:value="dataForm.password" :placeholder="dataForm._id === '' ? '密码，留空则系统自动生成' : '密码，留空则不修改'"
              :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="商户类型" name="type">
            <a-select v-model:value="dataForm.type" :options="types" placeholder="请选择" :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="联系人" name="linkman">
            <a-input v-model:value="dataForm.linkman" placeholder="联系人" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="联系电话" name="linkphone">
            <a-input v-model:value="dataForm.linkphone" placeholder="联系电话" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="开户行" name="bankname">
            <a-input v-model:value="dataForm.bankname" placeholder="开户行" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="银行账号" name="bankaccount">
            <a-input v-model:value="dataForm.bankaccount" placeholder="银行账号" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="备注" name="remark">
            <a-input v-model:value="dataForm.remark" placeholder="备注" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <a-modal v-model:visible="bindlogisticscustomerModal" title="绑定物流客户账号" @ok="confirmbindlogisticscustomer"
    @cancel="cancelconfirmbindlogisticscustomer" ok-text="确认" cancel-text="取消" :confirm-loading="saving"
    :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
    <a-form ref="bindlogisticscustomerRef" name="bindlogisticscustomerForm" :model="bindlogisticscustomerForm"
      :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24" v-if="bindlogisticscustomerForm.number">
          <a-form-item label="商户ID" name="number">
            {{ bindlogisticscustomerForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="bindlogisticscustomerForm.name">
          <a-form-item label="商户名称" name="name">
            {{ bindlogisticscustomerForm.name }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="主账号" name="username">
            {{ bindlogisticscustomerForm.username }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="物流账号" name="logistics_customer_username" :rules="[{ required: true, message: '请输入物流账号' }]">
            <a-input v-model:value="bindlogisticscustomerForm.logistics_customer_username" placeholder="物流账号"
              :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <!-- 开通TMS -->
  <a-modal v-model:visible="open_tms_modal" title="开通TMS一件代发" :confirm-loading="saving"
    :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
    <a-form ref="open_tms_form_ref" name="open_tms_form" :model="open_tms_form" :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24" v-if="open_tms_form.number">
          <a-form-item label="商户ID" name="number">
            {{ open_tms_form.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="open_tms_form.name">
          <a-form-item label="商户名称" name="name">
            {{ open_tms_form.name }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="TMS仓库名称" name="warehouse_name" :rules="[{ required: true, message: '请输入物流账号' }]">
            <a-input v-model:value="open_tms_form.warehouse_name" placeholder="仓库名称-商户名称简写" :disabled="saving">
            </a-input>
            <span>
              命名规则：例如（ <span style="color: red;">万盟产业园-正博</span>）
            </span>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #footer>
      <a-button @click="cancel_confirm_open_tms">取消</a-button>
      <a-button type="primary" @click="confirm_open_tms">确定</a-button>
    </template>
  </a-modal>
</template>
<script setup>
import { PlusOutlined, EyeOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { dataIndex: 'org', width: 150 },
  { dataIndex: 'seller', width: 150 },
  { title: '开通供应链平台', dataIndex: 'is_open_sc', width: 100 },
  { title: '开通TMS一件代发', dataIndex: 'is_open_tms', width: 120 },
  { title: '绑定物流客户', dataIndex: 'logistics_customer_username', width: 120 },
  { dataIndex: 'link', width: 120 },
  { dataIndex: 'vip', width: 200 },
  { title: '备注', dataIndex: 'remark', width: 150, },
  { title: '创建时间', dataIndex: 'create_time', width: 150, },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
];

const { proxy } = getCurrentInstance();
const dataFormRef = ref();
const queryForm = ref({ name: "", isvip: null });
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const types = ref([]);
const dataForm = ref({});
const dataTitle = ref('');
const dataModal = ref(false);
const saving = ref(false);
const changeing_open_sc = ref({});
const changeing_open_tms = ref({});
const bindlogisticscustomerForm = ref({});
const bindlogisticscustomerModal = ref(false);
const bindlogisticscustomerRef = ref();
const height = ref(600);

const open_tms_modal = ref(false);
const open_tms_form_ref = ref();
const open_tms_form = ref({});

const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});
// 核心处理函数
const handleResize = () => {
  console.log('Vue中视口宽高：', window.innerWidth, window.innerHeight);
  let h = window.innerHeight - 300;
  if (h < 450) height.value = 450;
  else height.value = h;
};
const debouncedResize = proxy.$utils.debounce(handleResize);
const initResize = () => {
  window.addEventListener('resize', debouncedResize);
  handleResize(); // 初始执行
}
onMounted(() => {
  initResize();
  getData();
});
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/org/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      types.value = res.data.types;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "",
    number: 0,
    name: "",//商户名称
    username: "",//账号
    password: "",//密码
    type: null,//商户类型
    linkman: "",//联系人
    linkphone: "",//联系电话
    bankname: "",//开户行
    bankaccount: "",//银行账号
    remark: "",//备注
  };
};
const add = () => {
  dataForm.value = initForm();
  dataTitle.value = '新增商户';
  dataModal.value = true;
};
const edit = (item) => {
  dataForm.value = _.pick(item, _.keys(initForm()));
  dataTitle.value = '编辑商户';
  dataModal.value = true;
}
const save = async () => {
  try {
    await dataFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/org/save", { dataForm: dataForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        dataModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  dataFormRef.value.clearValidate();
  dataModal.value = false;
};
const change_open_sc = (_id, is_open_sc) => {
  console.log('change_open_sc', _id, is_open_sc);
  changeing_open_sc.value[_id] = true;
  proxy.$api.doAPI("/org/change_open_sc", { _id, is_open_sc }).then((res) => {
    changeing_open_sc.value[_id] = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    changeing_open_sc.value[_id] = false;
    console.error(err);
  });
}
const change_open_tms = (record, is_open_tms) => {
  console.log('change_open_tms', record, is_open_tms);
  open_tms_modal.value = true;
  open_tms_form.value = {
    _id: record._id,
    is_open_tms,
    number: record.number,
    name: record.name,
    warehouse_name: "",
    warehouse_names: record.warehouse_names,
  };
}
const confirm_open_tms = async () => {
  try {
    await open_tms_form_ref.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/org/change_open_tms", open_tms_form.value).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        open_tms_modal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancel_confirm_open_tms = () => {
  open_tms_form_ref.value.clearValidate();
  open_tms_modal.value = false;
};
const bindlogisticscustomer = (item) => {
  bindlogisticscustomerForm.value = {
    _id: item._id,
    number: item.number,
    name: item.name,
    username: item.name,
    logistics_customer_username: item.logistics_customer_username || "",
    logistics_customer_name: item.logistics_customer_name,
    logistics_customer_id: "",
  };
  bindlogisticscustomerModal.value = true;
}
const confirmbindlogisticscustomer = async () => {
  try {
    await bindlogisticscustomerRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/org/bindlogisticscustomer", bindlogisticscustomerForm.value).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        bindlogisticscustomerModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelconfirmbindlogisticscustomer = () => {
  bindlogisticscustomerRef.value.clearValidate();
  bindlogisticscustomerModal.value = false;
};
const gettypename = (type) => {
  return _.findWhere(types.value, { value: type })?.label;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

p {
  margin: 0;
  padding: 0;
}
</style>